module.exports = __webpack_public_path__ + "img/pp4.5e7a4f06.png";